import { Colors } from '../../colors'
import type { ComponentsThemeBase } from './types'

export const lightTheme: ComponentsThemeBase = {
  backgroundColor: Colors.GS0,
  onBackgroundColor: Colors.GS1000,
}
